import { useId } from 'react';
import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../utils/cx';

export interface CardProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  as?: 'div' | 'section' | 'article';
  title?: ReactNode;
  titleLevel?: 2 | 3;
  description?: ReactNode;
  /** Actions secondaires alignées à droite du titre. */
  actions?: ReactNode;
  /** Carte blanche translucide (repli opaque si le flou n'est pas supporté). */
  translucent?: boolean;
  padding?: 'md' | 'lg';
}

export function Card({
  as: Tag = 'section',
  title,
  titleLevel = 2,
  description,
  actions,
  translucent = false,
  padding = 'md',
  className,
  children,
  ...rest
}: CardProps) {
  const titleId = useId();
  const Heading = titleLevel === 2 ? 'h2' : 'h3';
  return (
    <Tag
      className={cx(
        'av-card',
        translucent && 'av-card--translucent',
        padding === 'lg' && 'av-card--lg',
        className,
      )}
      aria-labelledby={title && Tag !== 'div' ? titleId : undefined}
      {...rest}
    >
      {title || actions ? (
        <div className="av-card__header">
          <div>
            {title ? (
              <Heading id={titleId} className="av-card__title">
                {title}
              </Heading>
            ) : null}
            {description ? <p className="av-card__description">{description}</p> : null}
          </div>
          {actions ? <div className="av-row">{actions}</div> : null}
        </div>
      ) : null}
      {children}
    </Tag>
  );
}
